export const data = {
    turn: "",
    storyImage: {
        outline: "outline",
        colored: "coloredImage"
    },
    drawHistory: [],
    storyKey: "",
    isTwoPlayer: false,
    lastPlayer: 1,
    lastMuppet: -1,
    english: true,
    transition: {},
    isDebug: false,
    maxImages: 5,
    groverTransition: false,
    loadBar: {},
    gameBootTime: 0,
    storiesPlayed: 0,
    pdfsDownloaded: 0,
    currentStateName: "Title Screen"
}

export function sendEvent(action, label, value) {
    let params = {
        hitType: 'event',
        eventCategory: "Grover's Story Circle",
        eventAction: action,
        eventLabel: label
    };

    if(value)
    {
        params.eventValue = value;
    }

    window.ga('send', params);
}

export function fixNumber(x) {
    if(x < 10) x = "0" + x;
    if(x > 10) x = "10+";
    return x;
}
